import adminChange from './adminChange';
import portalChange from './portalChange';

export default [adminChange, portalChange];
